import { FC } from 'react';
import { faEnvelope, faIdBadge, faIdCard, faMobile, faUser } from '~/assets';
import { formatPhone, maskCpfOrCnpj } from '~/utils';
import HeaderModal from '../HeaderModal';
import Item from './Item';
import { Column, Content, Wrapper } from './styles';

type Props = {
  customer: Customer;
  isOpen: boolean;
  handleClose(): void;
};

const ModalCustomerDetails: FC<Props> = ({ customer, isOpen, handleClose }) => {
  return (
    <Wrapper isOpen={isOpen} onClose={handleClose}>
      <HeaderModal title="Dados do customer" onPressClose={handleClose} />
      <Content>
        <Column>
          <Item label="NOME" icon={faUser} value={customer?.name} />
          <Item
            label="TELEFONE"
            icon={faMobile}
            value={formatPhone(customer?.phone)}
          />
          <Item label="EMAIL" icon={faEnvelope} value={customer?.email} />
        </Column>
        <Column>
          <Item
            label="DOCUMENTO"
            icon={faIdCard}
            value={maskCpfOrCnpj(customer?.refDocument)}
          />
          <Item label="TIPO" icon={faIdBadge} value={customer?.type} />
          <Item label="APELIDO" icon={faUser} value={customer?.nickName} />
        </Column>
      </Content>
    </Wrapper>
  );
};

export default ModalCustomerDetails;
